export const TOOLTIPS = {
  NEXRAD: "Next Generation Weather Radar are Doppler radars that detect and produce over 100 different long-range and high-altitude observations, including precipitation, winds, and thunderstorms.",
  NOAA: "The National Oceanic and Atmospheric Administration is a division of the U.S. Department of Commerce. NOAA’s database tracks and details severe weather events.",
};